import { Status } from '../types';

export const getStatus = (disabled: boolean, hasError: boolean): Status => {
  if (disabled) return 'disabled';
  if (hasError) return 'error';
  return 'active';
};
